var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.46 20v5.1h4.48V38.07h-.743v-12.23H17.093v12.23H16V40h21v-1.929h-1.093V20H25.461zm6.244 3.661h2.197v-1.946h-2.197v1.946zm-4.237 0h2.197v-1.946h-2.197v1.946zm4.237 3.366h2.197V25.08h-2.197v1.946zm-6.152 2.76h2.197V27.84h-2.197v1.946zm-3.506 0h2.198V27.84h-2.198v1.946zm-3.504 0h2.197V27.84h-2.197v1.946zm13.162.606h2.197v-1.946h-2.197v1.946zm-6.152 2.76h2.197v-1.946h-2.197v1.945zm-3.506 0h2.198v-1.946h-2.198v1.945zm-3.504 0h2.197v-1.946h-2.197v1.945zm13.162.605h2.197v-1.945h-2.197v1.945zm-6.152 2.76h2.197v-1.946h-2.197v1.946zm-3.506 1.553h2.198v-3.499h-2.198v3.5zm-3.504-1.553h2.197v-1.946h-2.197v1.946zm13.162.606h2.197v-1.946h-2.197v1.946z",
    transform: "translate(-58 -612) translate(42 592)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/company_icon.7039b40a4dfefe622b5a14ea14363e99.svg";
export { ForwardRef as ReactComponent };